export default __webpack_public_path__ + "static/PlayfairDisplay-Italic-VariableFont_wght-f8135af105ed89da616c952969937030.woff";